<template>
  <div class="real_item">
    <div class="top">
      <div class="name taj">{{ item.test_name }}</div>
      <div class="answer_count">
        <img src="@/assets/home/sign_count.png" alt="" />
        <p>{{ item.count }}人已做</p>
      </div>
    </div>
    <div class="bot">
      <a
        :class="['l', item.pdf_url ? 'download_pdf' : '']"
        :href="item.pdf_url"
        :download="item.test_name"
        target="_blank"
      ></a>
      <div class="r">
        <router-link :to="`/list/2/${item.test_id}`" target="_blank">
          <div class="toIntro tac">查看详情</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: Object,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.real_item {
  float: left;
  width: 384px;
  height: 211px;
  background: #ffffff;
  border-radius: 8px;
  margin-right: 24px;
  margin-top: 24px;
  .name {
    font-size: 18px;
    font-weight: bold;
    color: #1f1f1f;
  }
}
.real_item:nth-child(1),
.real_item:nth-child(2),
.real_item:nth-child(3) {
  margin-top: 0;
}
.top {
  padding: 0 30px;
  height: 134px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.answer_count {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #4f5666;
  padding-top: 20px;
  img {
    margin-right: 10px;
  }
}

.bot {
  height: 76px;
  padding: 0 30px;
  border-top: 1px solid #e9e9e9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .download_pdf {
    width: 36px;
    height: 36px;
    background: url("@/assets/home/download.png");
  }
  .r div {
    width: 110px;
    height: 36px;
    border-radius: 18px;
    font-size: 16px;
    line-height: 36px;
    float: left;
    cursor: pointer;
  }
  .toanswer {
    background: #479dff;
    color: #ffffff;
  }
  .toAnalysis {
    border: 1px solid #00c87f;
    color: #00c87f;
    margin-right: 10px;
  }
  .toAgainAnswer {
    border: 1px solid #479dff;
    color: #479dff;
  }
  .toIntro {
    background: #479dff;
    color: #ffffff;
  }
}

.real_item:nth-child(3n) {
  margin-right: 0;
}
.real_item:hover {
  transform: translateY(-6px);
  -webkit-transform: translateY(-6px);
  -moz-transform: translateY(-6px);
  box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.5);
  -webkit-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.5);
  -moz-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.5);
  /* box-shadow     : 0px 5px 33px 2px rgba(182, 208, 249, 1); */
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  .download_pdf {
    background: url("@/assets/home/download_hover.png");
  }
}
</style>
